const attributes = {
    currentItemAttribute: 'js-header-current-item',
    hasChildrenAttribute: 'js-header-current-item-has-children',
    noLinkAttribute: 'js-header-no-link',
    idAttribute: 'id',
    backAttribute: 'js-header-back',
}

const classes = {
    item: 'header__menu__item',
    link: 'header__menu__item__link',
    h5: 'h5',
    h4: 'h4',
    p: 'p',
    submenuLink: 'header__menu__item__link--submenu',
    noLink: 'no-link',
    back: 'header__menu__back',
    title: 'header__menu__title',
    smallLink: 'header__menu__link',
    cta: 'header__menu__cta',
}

export const createItem = (item, menu, submenu) => {
    const li = document.createElement('li');
    const a = document.createElement('a');

    a.innerHTML = item.name;
    a.href = item.url;
    a.target = item.target;
    a.classList.add(classes.link, submenu ? classes.submenuLink : classes.h5, classes.noLink);

    a.setAttribute(attributes.idAttribute, item.ID);

    if (item.has_child_class && item.children.length) {
        a.toggleAttribute(attributes.noLinkAttribute)
        li.toggleAttribute(attributes.hasChildrenAttribute);
    }

    li.toggleAttribute(attributes.currentItemAttribute);

    item.classes.map(className => {
        if (className) {
            li.classList.add(className);
        }
    });

    li.classList.add(classes.item)

    li.append(a);

    menu.append(li);
}

export const createSubMenuHeader = (item, menu) => {
    const backButton = document.createElement('div');
    const title = document.createElement('h4');

    backButton.innerHTML = 'Retour';
    backButton.classList.add(classes.back, classes.p)
    backButton.toggleAttribute(attributes.currentItemAttribute);
    backButton.toggleAttribute(attributes.backAttribute);
    backButton.setAttribute(attributes.idAttribute, item.ID);

    title.innerHTML = item.name;
    title.classList.add(classes.h4, classes.title);
    title.toggleAttribute(attributes.currentItemAttribute);

    menu.append(backButton);
    menu.append(title);
}

export const createSmallLink = (item, menu) => {
    const link = document.createElement('a');
    const i = document.createElement('i');

    i.classList.add(item.icon);
    link.innerHTML = item.title;
    link.href = item.url;
    link.classList.add(classes.smallLink);
    link.append(i);
    link.toggleAttribute(attributes.currentItemAttribute);

    menu.append(link)
}

export const createCta = (item, menu) => {
    const link = document.createElement('a');

    link.innerHTML = item.title;
    link.href = item.url;

    item.classes.split(' ').forEach(className => {
        link.classList.add(className);
    });
    link.classList.add(classes.cta);

    link.toggleAttribute(attributes.currentItemAttribute);

    menu.append(link)
}

export const createMobileItem = (item, menu) => {

}
